import { useFormikContext } from 'formik'
import React, { useState } from 'react'
import { Button, Col, Row, Stack } from 'react-bootstrap'
import LabelRequired from 'src/app/modules/component/LabelRequired'
import TextField from 'src/app/modules/component/TextField'
import { CODE_GENERATE_FORM } from 'src/app/modules/utils/Constant'
import ModalChonKetQuaDichVu from '../../../components/tab-kham-benh/modal-chon-ket-qua-dich-vu/ModalChonKetQuaDichVu'
import { KetQuaDichVu } from '../../../models/ThongTinKhamBenhModel'

const KetQuaClsChuyenTuyen = ({ visitId }: any) => {
    const { values, setFieldValue, handleChange } = useFormikContext<any>();
    const [openModalChonKetQuaDichVu, setOpenModalChonKetQuaDichVu] = useState<boolean>(false);

    const handleSelectKetQua = (selectedData: KetQuaDichVu[]) => {
        let htClinicalResults = selectedData?.map(item =>
            `${item.tenDichVu} ${item.ketQua !== null ? '(' + item.ketQua + ')' : ''}`
        ).join(', ');
        setFieldValue(`${CODE_GENERATE_FORM.xuTriThongTinChuyenTuyen}.htClinicalResults`, htClinicalResults);
    };

    return (
        <>
            <Row className="spaces mt-6">
                <Col xs={12}>
                    <Stack direction="horizontal" className="justify-content-between">
                        <LabelRequired label="Tóm tắt kết quả CLS có giá trị chẩn đoán" />
                        <Button
                            className="bg-white spaces px-2"
                            onClick={() => setOpenModalChonKetQuaDichVu(true)}
                        >
                            <u className="fw-bold color-17A2B8 fs-13px">Chọn kết quả</u>
                        </Button>
                    </Stack>
                </Col>
                <Col xs={12}>
                    <TextField
                        className="resize-none w-100"
                        as="textarea"
                        rows="3"
                        name="hdClinicalResults"
                        values={values?.hdClinicalResults || ''}
                        onChange={handleChange}
                    />
                </Col>
            </Row>
		    {openModalChonKetQuaDichVu && (
		    	<ModalChonKetQuaDichVu
		    		open={openModalChonKetQuaDichVu}
		    		handleClose={() => setOpenModalChonKetQuaDichVu(false)}
		    		onSave={handleSelectKetQua}
		    		visitId={visitId}
		    	/>
		    )}
        </>
    )
}

export default KetQuaClsChuyenTuyen